export const REQUEST_AUTH_TOKEN = 'REQUEST_AUTH_TOKEN';
export const HOST_AUTH_TOKEN = 'HOST_AUTH_TOKEN';
